import {Controller} from "@hotwired/stimulus";
import {Component, getComponent} from "@symfony/ux-live-component";

type Constructor<T = {}> = new (...args: any[]) => T;

export function LiveComponentToolsController<Base extends Constructor<Controller>>(Base: Base) {
    const derived = class extends Base
    {
        public async getComponent(): Promise<Component> {
            return await getComponent(this.element as HTMLElement);
        }

        public async render(): Promise<void> {
            try {
                const component = await this.getComponent();
                await component.render();
            } catch (error) {
                console.error("Error rendering component:", error);
            }
        }
    }
    return derived;
}
